import React from 'react';
import { Color } from 'modules/styles/colors';

const a = {
  fill: Color.black
} as const;

export default {
  svg: (
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="collections" transform="translate(-700.000000, -251.000000)" fill="#222222">
        <g id="Group" transform="translate(699.000000, 251.000000)">
          <g id="Icons-/-Check-Square" transform="translate(1.000000, 0.000000)">
            <path
              {...a}
              d="M11.9556007,4.712977 L11.9556007,7.14696782 L2.43399082,7.14696782 L2.43399082,21.1308942 L16.4179172,21.1308942 L16.4179172,12.4206146 L18.851908,12.4206146 L18.851908,23.564885 L2.66453526e-14,23.564885 L2.66453526e-14,4.712977 L11.9556007,4.712977 Z M19.2567083,1.0125234e-12 L21.2896547,1.362118 L9.41308809,19.0144244 L4.06291121,10.7840451 L6.11724331,9.45402104 L9.44818674,14.5782956 L19.2567083,1.0125234e-12 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 22 24'
};
